import { createUseStyles } from 'react-jss'

import { colors } from 'components/common'

const useIframePageStyles = createUseStyles({
  iframe: {
    height: '100%',
    width: '100%',
    border: 0
  },
  iframeWrapper: {
    padding: 15,
    height: '100%',
    overflow: 'hidden'
  },
  iframeNav: {
    display: 'flex',
    backgroundColor: colors.gray100,
    borderBottom: '10px solid #fff',
    '& > a': {
      color: '#333',
      padding: '1rem',
      border: 0,
      '&:hover': {
        backgroundColor: '#fff',
        color: colors.primary1
      }
    }
  },
  iframeLink: {
    '&.active': {
      backgroundColor: '#fff',
      color: `${colors.primary1} !important`
    },
    '&.disabled': {
      pointerEvents: 'none',
      opacity: 0.4
    }
  },
  iframeContent: {
    display: 'flex',
    backgroundColor: '#fff',
    height: 'calc(100% - 55px)'
  }
})

export { useIframePageStyles }
